import { defaultCacheableSingleton } from '@/lib/cacheable';
import { JobBlockDisplayType, Page, RowrowComponentsUnion } from '@/lib/types';

import lookerQueryClient from '@/pages/api/api-clients/looker-query-api-client';
import { endOfDay } from '@/utils/date-utils';
import { getPageComponents } from '@/utils/page-static-utils';

type TPopularLocation = {
  state: string;
  city: string;
  location_api_id: string;
  specialty: string;
  discipline: string;
  weekly_pay: number;
};

export type PopularLocationsResponse = TPopularLocation[];

const getPopularLocations = async () => {
  return defaultCacheableSingleton.remember(
    'looker:popularLocations',
    async () => {
      return lookerQueryClient
        .get('api/v1/looker/popular-locations')
        .then((response) => response.data.data);
    },
    endOfDay(new Date())
  );
};

const get = async (page: Page): Promise<PopularLocationsResponse> => {
  const hasPopularLocationsCheck = (rc: RowrowComponentsUnion) =>
    rc.__typename === 'JobBlock' &&
    rc.jobBlockDisplayType === JobBlockDisplayType.Locations;
  const hasPopularLocations =
    getPageComponents(page, hasPopularLocationsCheck).length > 0;

  return hasPopularLocations ? await getPopularLocations() : [];
};

const PopularLocationsService = {
  get,
};

export default PopularLocationsService;
